import axios from '../plugins/axios'
import initValuesFromDom from '../mixins/initValuesFromDom'

export default {
  mixins: [initValuesFromDom],
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',

      email: '',
      first_name: '',
      last_name: '',
      billing_company: '',
      billing_phone: '',
    }
  },
  beforeMount() {
    this.initValuesFromDom()
  },
  methods: {
    update_user_info () {
      if (this.loading) {
        return
      }

      this.loading = true
      this.messageType = 'error'
      this.errors.clear()

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    submit () {
      const formData = new FormData(this.$el)

      this.loading = true
      this.errors.clear()

      axios.post('', formData)
        .then(response => {
          this.messageType = 'success'
          this.errors.add({ msg: 'הפרטים עודכנו בהצלחה' })
        })
        .catch(error => {
          this.messageType = 'error'

          for (const errorKey in error.response.data.data) {
            this.errors.add({
              field: errorKey,
              msg: error.response.data.data[errorKey],
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/update_user_info.js